module.exports = __webpack_public_path__ + "static/media/img_qudao9@2x.2d217cfa.png";